import React from "react";
import {TabNavItem, Tab} from "./TabNavItem";

interface RoomEditTabProps {
  currentTab: Tab;
  setCurrentTab: React.Dispatch<React.SetStateAction<Tab>>;
}

export const TabNav = (props: RoomEditTabProps) => {
  const { currentTab, setCurrentTab } = props;

  return (
    <ul className="bg-primary list-reset flex gap-1" role="tablist">
      <TabNavItem
        {...{
          tab: Tab.BASIC,
          tabName: '基本情報',
          currentTab,
          setCurrentTab,
        }}
      />
      <TabNavItem
        {...{
          tab: Tab.THREE_D_SPACE,
          tabName: '3D空間',
          currentTab,
          setCurrentTab,
        }}
      />
      <TabNavItem
        {...{
          tab: Tab.VH_DEFINE,
          tabName: 'VH定義',
          currentTab,
          setCurrentTab,
        }}
      />
      <TabNavItem
        {...{
          tab: Tab.MENU_SET,
          tabName: 'メニューセット',
          currentTab,
          setCurrentTab,
        }}
      />
    </ul>
  )
}